import { useEffect, useState } from "react"
import { AvField } from "availity-reactstrap-validation"
import { Alert, Col, Row } from "reactstrap"
import { Link } from "react-router-dom"
import { Label, FormGroup, Input } from "reactstrap"
import OfficerChecklistReviewForm from "pages/Application/EnvironmentalAudit/OfficerChecklistReviewForm"

import Application from "services/applications/Application.service"
import EnvAuditService from "services/applications/envAudit/EnvAuditService"
import TinyMCEEditor from "components/RichTextEditor/TinyMCEEditor"

const BASE_URL = process.env.REACT_APP_BASE_URL

let officerInfo = JSON.parse(localStorage.getItem("authUser"))
let appService = new Application(officerInfo)

const envAuditService = new EnvAuditService(
  JSON.parse(localStorage.getItem("authUser"))
)

const OfficerFormEnvironmentalAudit = props => {
  const [officerSubmitted, setofficerSubmitted] = useState(false)
  const [showComments, setshowComments] = useState()
  const [comments, setcomments] = useState()

  const [applicationPhase, setapplicationPhase] = useState("phase 1")
  const [checklistDocument, setChecklistDocument] = useState(null)
  const [inspectionReport, setinspectionReport] = useState(null)
  const [showInspectionDocs, setshowInspectionDocs] = useState(false)
  const [auditReportComments, setauditReportComments] = useState(null)
  const [showDraftToRUpload, setshowDraftToRUpload] = useState(false)

  // checklist review
  const [checklistFormData, setchecklistFormData] = useState({})
  const [questions, setQuestions] = useState([])
  const [existingChecklists, setexistingChecklists] = useState([])
  const [mountChecklists, setmountChecklists] = useState(false)

  const [approvalConditions, setapprovalConditions] = useState("")
  const [mountRichText, setmountRichText] = useState(false)
  const [mountToR, setmountToR] = useState(false)
  const [applicationToR, setapplicationToR] = useState("")
  const [showCertificatePreview, setshowCertificatePreview] = useState(false)

  const [showDraftToRPreview, setshowDraftToRPreview] = useState(false)
  const [returnToApplicant, setreturnToApplicant] = useState(false)

  const certPreviewUrl =
    BASE_URL + "verify/certificate/" + props.appDetails.app_id + "?preview=true"

  const finalTorUrl = BASE_URL + "verify/tor/" + props.appDetails.app_id
  const torPreviewUrl =
    BASE_URL + "verify/tor/" + props.appDetails.app_id + "?preview=true"

  useEffect(() => {
    if (props.appDetails.is_application_in_phase_2) {
      setapplicationPhase("phase 2")
    }
    if (props.appDetails.approval_conditions != null) {
      setapprovalConditions(props.appDetails.approval_conditions)
    }
    if (props.appDetails.application_tor != null) {
      setapplicationToR(props.appDetails.application_tor)
    }

    setmountRichText(true)
    setmountToR(true)
    fetchReviewQuestions()
    fetchApplicationCheckList()
  }, [])

  const fetchReviewQuestions = () => {
    envAuditService.getAllChecklistQuestions().then(response => {
      //   console.log("questions -----> ", response);
      if (response.status) {
        setQuestions(response.data)
      }
    })
  }

  const fetchApplicationCheckList = () => {
    envAuditService
      .getApplicationChecklist(props.appDetails.id)
      .then(response => {
        // console.log("application checklist ", response)
        if (response.status) {
          setexistingChecklists(response.data)
        }
        setmountChecklists(true)
      })
  }

  const decisionValueChange = value => {
    const commentsCodes = ["011", "012"]
    if (commentsCodes.includes(value)) {
      setshowComments(true)
    } else {
      setcomments("")
      setshowComments(false)
    }

    // officer will upload files if code is 017
    if (value == "017") {
      setshowInspectionDocs(true)
      setshowDraftToRUpload(true)
      setshowDraftToRPreview(true)
    } else {
      setshowDraftToRUpload(false)
      setshowDraftToRPreview(false)
    }

    // show certificate preview
    if (value == "010") {
      setshowCertificatePreview(true)
    } else {
      setshowCertificatePreview(false)
    }

    // If return to applicant, don't show inspection report
    if (value == "012") {
      setmountChecklists(false)
      setreturnToApplicant(true)
    } else {
      setmountChecklists(true)
      setreturnToApplicant(false)
    }
  }

  const handleFileChange = (event, setFile) => {
    const file = event.target.files[0]
    setFile(file)
  }

  async function uploadDocuments() {
    if (applicationPhase == "phase 2") {
      submitCheckListReview()
    }

    if (inspectionReport) {
      const termsReport = {
        file: inspectionReport,
        application_id: props.appDetails.id,
        description: "Inspection Report",
      }

      const response = await appService.uploadFile(termsReport)
    }

    // upload audit report with comments

    if (auditReportComments) {
      const termsReport = {
        file: auditReportComments,
        application_id: props.appDetails.id,
        description: "Audit_Report_with_Comments",
      }

      const response = await appService.uploadFile(termsReport)
    }
  }

  const handleCheckListChange = formData => {
    // console.log("checklist form data ", {name: name, value: value})
    setchecklistFormData(formData)
    // console.log("checklistFormData --> ", checklistFormData)
  }

  const submitCheckListReview = () => {
    const responses = questions.map(question => {
      const isCompliant = checklistFormData[`question-${question.id}`] === "Yes"
      const officerNotes = checklistFormData[`notes-${question.id}`] || ""

      return {
        application_id: props.appDetails.id,
        check_list_question_id: question.id,
        is_compliant: isCompliant,
        officer_notes: officerNotes,
      }
    })

    const submitData = {
      application_id: props.appDetails.id,
      data: responses,
    }

    // console.log("Form Responses:", responses);

    envAuditService.createApplicationChecklist(submitData).then(response => {
      // console.log("submitted checklist review ", response)
    })
  }

  // RichText
  const handleEditorChange = content => {
    // console.log("HTML Content:", content)
    setapprovalConditions(content)
  }

  const handleToREditorChange = content => {
    // console.log("HTML Content:", content)
    setapplicationToR(content)

    // Save ToR
  }

  // saveDraftTermsOfReference
  const saveDraftTermsOfReference = draftTor => {
    const data = {
      application_id: props.appDetails.id,
      application_tor: draftTor,
    }
    envAuditService.updateTermsOfReference(data).then(response => {
      // console.log("response save draft ToR", response)
    })
  }
  return (
    <>
      <div>
        <AvField
          type="hidden"
          name="application_id"
          value={props.appDetails.id}
        />
        <AvField
          type="hidden"
          name="approval_conditions"
          value={approvalConditions}
        />

        <AvField type="hidden" name="application_tor" value={applicationToR} />
      </div>

      <div>
        {props.error && props.error == true ? (
          <Row className="alert alert-danger">
            <Col md="12">{props.message}</Col>
          </Row>
        ) : null}

        {props.success && props.success == true ? (
          <Row className="alert alert-success">
            <Col md="8">{props.message}</Col>
            <Col md="4">
              <Link to="/dashboard" style={{ float: "right" }}>
                Back
              </Link>
            </Col>
          </Row>
        ) : null}
      </div>

      {applicationPhase == "phase 2" ? (
        <>
          <Alert color="info">
            Applicant has uploaded additional documents. Please check them in
            the <b>Appplication Details</b> below
            <br></br>
            <br></br>
            Click below to view final ToR Certificate.
            <a className="linkItem" target="_blank" href={finalTorUrl}>
              Final Terms of Reference{" "}
              <i className="fa fa-certificate" title="ToR Certificate"></i>
            </a>
          </Alert>
        </>
      ) : null}

      <div className="mb-3">
        <AvField
          disabled={props.success}
          type="select"
          name="decision_code"
          label="Select Decision"
          //value={defaultValues.decision_code}
          required
          onChange={v => {
            decisionValueChange(v.target.value)
          }}
        >
          <option value="">--select Decision--</option>

          {applicationPhase == "phase 1" ? (
            <option value="017">
              Propose for Terms of Reference Acquisition
            </option>
          ) : (
            <option value="010">Propose to Approve</option>
          )}

          <option value="011">Propose to Reject</option>
          <option value="012">Return to Applicant</option>
        </AvField>
      </div>

      <Row className="mb-3">
        <label htmlFor="reason" className="col-lg-3 col-form-label">
          Reason
        </label>
        <div className="col-lg-9">
          <AvField
            disabled={props.success}
            type="textarea"
            // value={defaultValues.reason}
            id="reason"
            name="reason"
            rows="2"
            required
            className="form-control"
          ></AvField>
        </div>
      </Row>

      {showInspectionDocs ? "" : null}

      {/* Upload minutes from committee meeting */}
      {applicationPhase === "phase 2" ? (
        <FormGroup>
          <br></br>
          <Label for="auditReportComments">
            {/* Minutes Document from Committee Meeting */}
            Audit Report with Comments
          </Label>
          <br></br>
          <AvField
            className="btn"
            type="file"
            name="auditReportComments"
            id="auditReportComments"
            accept=".pdf,.doc,.docx"
            onChange={e => handleFileChange(e, setauditReportComments)}
            required={true}
          />
        </FormGroup>
      ) : null}

      {/* Draft Terms of Reference */}
      {showDraftToRUpload ? (
        <FormGroup>
          <TinyMCEEditor
            label="Draft Terms of Reference"
            value={applicationToR}
            onChange={handleToREditorChange}
            onBlur={saveDraftTermsOfReference}
          />
        </FormGroup>
      ) : null}

      {applicationPhase == "phase 1" & returnToApplicant == false ? (
        <>
          <br></br>
          <label>Upload Inspection Report</label>

          {/* This is uploaded in phase 1 */}
          {showDraftToRPreview? <Row className="mb-3">
            <Alert color="info">
              Before submitting your review, please click on the preview link
              below to see how the ToR draft will display after the
              approval processes.
            </Alert>
            <a className="linkItem" target="_blank" href={torPreviewUrl}>
              Preview ToR{" "}
              <i className="fa fa-certificate" title="Preview Draft ToR"></i>
            </a>
          </Row> : null}
          

          <AvField
            className="btn"
            type="file"
            name="inspectionReport"
            id="inspectionReport"
            accept=".pdf,.doc,.docx"
            onChange={e => handleFileChange(e, setinspectionReport)}
            required={false}
          />
        </>
      ) : (
        ""
      )}

      {/* Env Audit Form */}
      {mountChecklists && applicationPhase == "phase 2" ? (
        <OfficerChecklistReviewForm
          existingChecklists={existingChecklists}
          handleChange={handleCheckListChange}
          isReadOnly={false}
        />
      ) : null}

      {/* RichText */}
      <div>
        {mountRichText && applicationPhase === "phase 2" ? (
          <TinyMCEEditor
            value={approvalConditions}
            onChange={handleEditorChange}
          />
        ) : null}
      </div>

      {/* <a href="#" onClick={submitCheckListReview}>Test Submit CheckList</a> */}
      {/* End of Env Audit Form */}

      {/* {showCertificatePreview ? (
        <Row className="mb-3">
          <Alert color="info">
            Before submitting your review, please click on the preview link
            below to see how the certificate will display after the approval
            processes.
          </Alert>
          <a className="linkItem" target="_blank" href={certPreviewUrl}>
            Preview Certificate{" "}
            <i className="fa fa-certificate" title="Preview Certificate"></i>
          </a>
        </Row>
      ) : null} */}

      {showComments ? (
        <Row className="mb-3">
          <label
            htmlFor="comment_to_applicant"
            className="col-lg-3 col-form-label"
          >
            Comments to applicant
          </label>
          <div className="col-lg-9">
            <AvField
              disabled={props.success}
              type="textarea"
              id="comment_to_applicant"
              name="comment_to_applicant"
              //value={defaultValues.comment_to_applicant}
              rows="4"
              required
              className="form-control"
              onChange={v => {
                //setcomments(v.target.value)
              }}
            ></AvField>
          </div>
        </Row>
      ) : null}
      {props.loading && props.loading === true ? (
        <Link
          to="#"
          className="spinner-border text-info"
          style={{ float: "right" }}
        />
      ) : (
        <div className="mt-5">
          <button
            className="btn btn-lg btn-primary col-12"
            disabled={props.success}
            onClick={uploadDocuments}
          >
            Review Report
          </button>
        </div>
      )}
    </>
  )
}

export default OfficerFormEnvironmentalAudit
